
  import { defineComponent } from 'vue';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import API from '../api/formula';
  import { getIsFormulaValid, normalizeFormula } from '../utils/formula';

  const FORMULA_CODE = 'TOP_EFFECTIVE_REGIONS_RATING';
  const FORMULA_MAX_LENGTH = 500;

  const FORMULA_ERROR_MESSAGE =
    'Формула содержит недопустимые символы. Разрешены параметры A, B, C, D, числа, знаки *, /, +, − и скобки.';

  const PERMISSIONS = {
    view: Constants.Permissions.FormulaView,
    edit: Constants.Permissions.FormulaEdit,
  };

  export default defineComponent({
    name: 'FormulaSettings',
    components: {
      InputBlock,
      ComponentInput,
      ButtonComponent,
    },
    mixins: [security],
    data() {
      return {
        formula: '',
        formulaMaxLength: FORMULA_MAX_LENGTH,
        isLoading: false,
        isSaving: false,
        canEdit: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.loadFormula();
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
      normalizedFormula(): string {
        return normalizeFormula(this.formula);
      },
      errorMessage(): string {
        if (!this.normalizedFormula) return '';

        return getIsFormulaValid(this.normalizedFormula) ? '' : FORMULA_ERROR_MESSAGE;
      },
      isValid(): boolean {
        return !!this.normalizedFormula && !this.errorMessage;
      },
      isSaveDisabled(): boolean {
        return !this.isValid || this.isSaving || this.isLoading || !this.canEdit;
      },
    },
    methods: {
      async loadFormula() {
        this.isLoading = true;

        try {
          const response = await API.getByCode(FORMULA_CODE);
          this.formula = response.data?.formulaText ?? '';
        } catch {
          Constants.alert.fire(Constants.errorTitle, 'Не удалось загрузить формулу.', 'error');
        } finally {
          this.isLoading = false;
        }
      },

      async save() {
        if (!this.isValid || !this.canEdit) return;

        this.isSaving = true;

        try {
          await API.update({ code: FORMULA_CODE, formula: this.normalizedFormula });
          Constants.alert.fire('Сохранение', 'Формула успешно обновлена', 'success');
        } catch {
          Constants.alert.fire(Constants.errorTitle, 'Не удалось сохранить формулу.', 'error');
        } finally {
          this.isSaving = false;
        }
      },
    },
  });
